/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'
export default {
  updateAlarm({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/alarm/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("UPDATE_ALARM", payload)
            resolve(response)
          }
          reject(response)
        }
      ).catch((error) => { reject(error) })
    })
  },
  deleteAlarm({ commit }, payload) {
    return new Promise((resolve, reject) => {
    axios.delete("/api/workspace/alarm/"+ payload)
      .then((response) => {
        if(response.data.result == 'success'){          
          commit("DELETE_ALARM", payload)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  getAlarm({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/alarm")
      .then((response) => {
        if(response.data.result == 'success'){
          commit("SET_ALARM_LIST", response.data.data_list)
        }
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  getNewAlarm({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/alarm/new")
      .then((response) => {
        if(response.data.result == 'success'){
          commit("SET_NEW_ALARM_LIST", response.data.data_list)
        }
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  setAlarmSearchQuery({ commit }, query){
    commit("SET_ALARM_SEARCH_QUERY", query)
  },
}
